




































import { defineComponent, type PropType } from "vue-demi";
import getValueForProp from "../../../helper/getValueForProp";
import GGGroupTitle from "../GGGroupTitle.vue";

import type {
  DataSourceResponse,
  PageDataPropUnion,
  FactoidPosition,
} from "@constructor/shared-entity/type";

export default defineComponent({
  name: "GGGroup",
  components: {
    GGGroupTitle,
  },
  props: {
    prop: {
      type: Array as PropType<PageDataPropUnion[]>,
      default: () => [],
    },
    order: {
      type: String as PropType<FactoidPosition>,
      default: "left",
    },
    enableFactoid: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object as PropType<DataSourceResponse>,
      default: () => ({}),
    },
  },
  computed: {
    title() {
      const type = getValueForProp("titleSourceType", this.prop);
      if (type === "from-data-source" && this.data?.title) {
        return this.data.title;
      } else {
        return getValueForProp("sectionTitle", this.prop);
      }
    },
    link() {
      const type = getValueForProp("linkSourceType", this.prop);
      if (type === "from-data-source" && this.data?.link) {
        return this.data.link;
      } else {
        return getValueForProp("sectionLink", this.prop);
      }
    },
    linkText() {
      return getValueForProp("linkSectionText", this.prop);
    },
    titleIconLeft() {
      return getValueForProp("titleIconLeft", this.prop) || undefined;
    },
    titleIconRight() {
      return getValueForProp("titleIconRight", this.prop) || undefined;
    },
    titleImageMobile() {
      return getValueForProp("titleImageMobile", this.prop) || undefined;
    },
    titleImageDesktop() {
      return getValueForProp("titleImageDesktop", this.prop) || undefined;
    },
    titleImageLink() {
      return getValueForProp("titleImageLink", this.prop) || undefined;
    },
    titlePromocode() {
      return getValueForProp("titlePromocode", this.prop) || undefined;
    },
    titlePromocodeColor() {
      return getValueForProp("titlePromocodeColor", this.prop) || undefined;
    },
    titleTimerDate() {
      return getValueForProp("titleTimerDate", this.prop) || undefined;
    },
    titleTimerColor() {
      return getValueForProp("titleTimerColor", this.prop) || undefined;
    },
    titleTimerSize() {
      return getValueForProp("titleTimerSize", this.prop) || undefined;
    },
  },
});
